import { fromJS } from 'immutable';
import { ApiUrl5, UserToken } from '../../../helper/HelperAuth'
import { GetBotInquiry } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl5 + 'chatbot-inquiry-answered';
    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(body)
    };

    const response = await doFetch(url, argument);
    var data = fromJS({});
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get("chatbot-inquiry")
        var x = []
        for (var i = 0; i < data.size; i++) {
            var datinti = data.get(i)
            var obj = { name: datinti.get("tanggal")}
            obj["Bot Inquiry Answered"] = parseInt(datinti.get("inquiry-answered"))
            x.push(obj)

        }
        data=x      
    }

    dispatch({ type: GetBotInquiry, data:data });
    return data
};